<div class="row" id="divFormGiftCardsConfigurationContribution">
    <div class="col-xs-12">
        <section class="ib-layout__section">
            <div class="ib-box ib-box--no-shadow ib-gift-cards__box">
                <form [formGroup]="form" id="formGiftCardsConfigurationContribution" (ngSubmit)="onSubmit()">
                    <div class="ib-layout__line-spacing ib-layout__line-spacing--large ">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="ib-layout__line-spacing ib-layout__line-spacing--large ">
                                    <ib-gift-cards-contribution-card-component [form]="form"></ib-gift-cards-contribution-card-component>
                                    <ib-gift-cards-contribution-info></ib-gift-cards-contribution-info>
                                </div>
                                <ib-gift-cards-contribution-import [form]="form"></ib-gift-cards-contribution-import>
                                <ib-gift-cards-contribution-sender-data [form]="form"></ib-gift-cards-contribution-sender-data>
                            </div>
                        </div>
                    </div>
                    <div class="ib-content-buttons ib-content-buttons--block-sm">
                        <div class="ib-content-buttons__content-left">
                            <button type="submit" class="ib-button ib-button--w-medium">{{'GIFT_CARD_CONFIGURATION_GO_TO_PAYMENT_BUTTON'|translate}}</button>
                        </div>
                        <div class="ib-content-buttons__content-right">
                            <a class="ib-link ib-link--medium" href="javascript:void(0)" (click)="cancel()"
                               title="{{'MODAL_CANCEL_TITLE_TEXT'|translate}}">{{'MODAL_CANCEL_TITLE_TEXT'|translate}}</a>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    </div>
</div>
